import axiosInstance from "./instance";

// Get All Vendors by Status
const fetchVendors = async (page, status) => {

    console.log(page);
    console.log(status);

    const response = await axiosInstance.get('/vendors', {
        params: {
            page,
            status
        }
    });
    return response.data;
}

// Get Rider Earning 
const getEarning = async (vendorId, startDate, endDate) => {
    const response = await axiosInstance.get(`/vendor/earning`, {
        params: {
            vendorId,
            startDate,
            endDate
        }
    });
    return response.data;
}


// Get Solo Order Details
const fetchVendor = async (vendorId) => {
    const response = await axiosInstance.get(`/vendor`, {
        params: {
            vendorId
        }
    });
    return response.data;
}

const updateVendor = async (vendorId, status) => {
    console.log(vendorId);
    console.log(status);
    const response = await axiosInstance.post('/vendor', {
        vendorId,
        status
    });
    console.log(response.data);
    return response.data;
}

const updatefeature = async (vendorId, status) => {
    const response = await axiosInstance.post('/vendor/feature', {
        vendorId,
        status
    });
    console.log(response.data);
    return response.data;
}

const fetchDashboardVendors = async () => {
    const response = await axiosInstance.get('/dashboard/vendors');
    return response.data;
}

const fetchDashboardUsers = async () => {
    const response = await axiosInstance.get('/dashboard/users');
    return response.data;
}

export { fetchVendors, fetchVendor, updateVendor, updatefeature, fetchDashboardVendors, fetchDashboardUsers, getEarning };